export default __webpack_public_path__ + "static/media/modely8.79e5669c.jpg";